import { type MutationHookOptions, useMutation } from "@apollo/client";
import { RetryDomainSetupMutation } from "../graphql/mutations";
import type {
  RetryDomainSetupMutationType,
  RetryDomainSetupMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useRetryDomainSetupMutation = (
  options?: MutationHookOptions<
    RetryDomainSetupMutationType,
    RetryDomainSetupMutationVariablesType
  >
) => {
  return useMutation<
    RetryDomainSetupMutationType,
    RetryDomainSetupMutationVariablesType
  >(RetryDomainSetupMutation, options);
};
